import PubSub from 'underpub-js';
import gsap from 'gsap';

var FilterMarkupMultiLevel = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'el-FilterMarkupMultiLevel',
  };

  $.extend(true, this.options, options);
};

FilterMarkupMultiLevel.prototype.init = function() {
  const self = this;

  self.$sublevelToggles = self.options.$el.find('[data-sublevel-toggle]');
  self.$levels = self.options.$el.find(`.${self.data.baseClass}__level`);
  self.$sublevels = self.options.$el.find('[data-sublevel]');
  self.$levelLists = self.options.$el.find(
    `.${self.data.baseClass}__level__list`,
  );
  self.$sublevelWrapper = self.options.$el.find(
    `.${self.data.baseClass}__sublevel-wrapper`,
  );
  self.$level1 = self.options.$el.find(
    `.${self.data.baseClass}__level--level1`,
  );
  self.$level2 = self.options.$el.find(
    `.${self.data.baseClass}__level--level2`,
  );
  self.$level3 = self.options.$el.find(
    `.${self.data.baseClass}__level--level3`,
  );
  self.$levelListItems = self.options.$el.find(
    `.${self.data.baseClass}__level__list__item`,
  );

  self.initSublevelToggles();
  self.initLevelListItems();
};

FilterMarkupMultiLevel.prototype.initSublevelToggles = function() {
  const self = this;

  self.$sublevelToggles.each((index, item) => {
    const $item = $(item);
    const $text = $item.closest(`.${self.data.baseClass}__level__list__item`);
    const $caratSVG = $item.find('svg');
    const dataIndex = $item.data('index');
    const $parentLevel = $item.closest(self.$levels);
    const $childrenToggles = $item.find(self.$sublevelToggles);
    let $sublevelParent;
    let $sublevel;
    let sublevelIsToggled = false;

    if ($parentLevel.is(self.$level1)) {
      $sublevelParent = self.$level2;
    }
    if ($parentLevel.is(self.$level2)) {
      $sublevelParent = self.$level3;
    }

    if (!$sublevelParent.length) return;

    $sublevel = $sublevelParent
      .find(self.$sublevels)
      .filter(`[data-parent-index="${dataIndex}"]`)
      .one();

    if (!$sublevel.length) return;

    const toggleToggledState = () => (sublevelIsToggled = !sublevelIsToggled);

    const sublevelTL = gsap
      .timeline({
        paused: true,
        onStart: toggleToggledState,
        onReverseComplete: toggleToggledState,
      })
      .to($caratSVG, {
        rotate: -90,
        fill: '#b04c2c',
        duration: 0.15,
        ease: 'expo.easeout',
      })
      .to(
        $text,
        {
          color: '#b04c2c',
          duration: 0.1,
          ease: 'expo.easeout',
        },
        '<',
      )
      .fromTo(
        $sublevelParent,
        {
          delay: () => ($parentLevel.is(self.$level1) ? 0.4 : 0),
          opacity: 0,
          duration: 0.15,
          ease: 'expo.easeout',
        },
        {
          opacity: 1,
        },
      )
      .to(
        self.$sublevelWrapper,
        {
          opacity: 1,
          duration: 0.15,
          ease: 'expo.easeout',
        },
        '<',
      )
      .fromTo(
        $sublevel,
        {
          display: 'none',
          opacity: 0,
          duration: 0.2,
          ease: 'expo.easeout',
          x: -20,
        },
        {
          display: 'block',
          opacity: 1,
          x: 0,
        },
        '<.15',
      );

    const openSublevel = (timeScale = 1) => {
      sublevelTL.timeScale(timeScale).restart(true);
      $parentLevel
        .find(self.$sublevelToggles)
        .not($item)
        .trigger('triggerCloseSublevel');
    };
    const closeSublevel = (timeScale = 1.5) => {
      sublevelTL.timeScale(timeScale).reverse();
      $sublevel.find(self.$sublevelToggles).trigger('triggerCloseSublevel');
    };

    const toggleSublevel = () =>
      !sublevelIsToggled ? openSublevel() : closeSublevel();

    $item.on('click', toggleSublevel);
    $item.on(
      'triggerCloseSublevel',
      () => sublevelIsToggled && closeSublevel(4),
    );
    $item.on('triggerOpenSublevel', () => !sublevelIsToggled && openSublevel());
  });
};

FilterMarkupMultiLevel.prototype.initLevelListItems = function() {
  const self = this;

  self.$levelListItems.each((index, item) => {
    const $item = $(item);
    const isActive = $item.hasClass(
      `${self.data.baseClass}__level__list__item--active`,
    );

    if (!isActive) return;

    const getLevelListIndex = (item) =>
      $(item)
        .closest(self.$levelLists)
        .data('parent-index');

    const getSublevelToggle = (level, index) =>
      $(level)
        .find(self.$sublevelToggles)
        .filter(`[data-index="${index}"]`)
        .one();

    const $itemSublevelToggle = $item.find(self.$sublevelToggles);
    const $itemLevel = $item.closest(self.$levels);
    let $parentLevel;
    let $grandParentLevel;

    const parentLevelIndex = getLevelListIndex($item);

    if ($itemSublevelToggle) {
      $itemSublevelToggle.trigger('triggerOpenSublevel');
    }

    if ($itemLevel.is(self.$level2)) {
      $parentLevel = self.$level1;
    }
    if ($itemLevel.is(self.$level3)) {
      $parentLevel = self.$level2;
      $grandParentLevel = self.$level1;
    }

    if ($parentLevel) {
      const $parentLevelToggle = getSublevelToggle(
        $parentLevel,
        parentLevelIndex,
      );

      if ($parentLevelToggle) {
        $parentLevelToggle.trigger('triggerOpenSublevel');

        if ($grandParentLevel) {
          const grandparentLevelIndex = getLevelListIndex($parentLevelToggle);

          const $grandParentLevelToggle = getSublevelToggle(
            $grandParentLevel,
            grandparentLevelIndex,
          );

          if ($grandParentLevelToggle) {
            $grandParentLevelToggle.trigger('triggerOpenSublevel');
          }
        }
      }
    }
  });
};

export default FilterMarkupMultiLevel;
